import { Component, OnInit, Input, EventEmitter, Output} from '@angular/core';

export const mimeTypeExtensions = [
  { type: 'application/pdf', extension: 'pdf'},
  { type: 'text/csv', extension: 'csv'},
  { type: 'application/msword', extension: 'doc'},
  { type: 'image/*', extension: 'imagen'}
];

@Component({
  selector: 'siu-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss']
})

export class UploadFileComponent implements OnInit  {


  @Input() fileLimit: any;
  // @Output() upLoadFile: EventEmitter<boolean>;
  @Output() upLoadFile: EventEmitter<File>;
  @Output() onWhenAddingFileFailed: EventEmitter<string>;
  @Output() deleteFile: EventEmitter<string>;
  // @Output() elementFile: EventEmitter<File>;

  //probando

  @Input() allowedMimeType: string[];

  files: any = [];
  fileSize: any;
  type =[".pdf"];

  constructor(){
    this.upLoadFile = new EventEmitter();
    this.onWhenAddingFileFailed = new EventEmitter();
    this.deleteFile = new EventEmitter();
    // this.elementFile = new EventEmitter();
  }

  ngOnInit(){

    // console.log('this.files');
    // console.log(this.files);
    // console.log('this.files.length');
    // console.log(this.files.length);

    // console.log('mimeTypeExtensions');
    // console.log(mimeTypeExtensions[0]);

    //this.upLoadTypeFile(event); 
  }

  //#region official uploadFile
  // uploadFile(event) {
  //   for (let index = 0; index < event.length; index++) {
  //     const element = event[index];
  //     this.files.push(element.name)
  //     console.log('this.files.length');
  //     console.log(this.files.length);
  //     console.log('element');
  //     console.log(element);

  //   //#region

  //   if (element)
  //   {

  //     if (element.size > 1024 * 1024)
  //       this.fileSize = (Math.round(element.size * 100 / (1024 * 1024)) / 100).toString() + 'MB';
  //     else
  //       this.fileSize = (Math.round(element.size * 100 / 1024) / 100).toString() + 'KB';

  //       console.log('this.fileSize');
  //       console.log(this.fileSize);

  //       console.log('element.size');
  //       console.log(element.size);

  //       // 6  megabyte equivalentes byte = 6291456
  //       // 20 megabyte equivalentes byte = 20971520
  //       console.log('this.fileLimit');
  //       console.log(this.fileLimit);

  //       //


  //       let message = `
  //       Sólo se permite archivos en formato
  //       ${this.allowedMimeType.map((i) =>
  //         (
  //           mimeTypeExtensions.find(x => x.type === i) || { extension: i }
  //         ).extension).join(', ')}`;
  //       console.log('message mimeType');
  //       console.log(message);

  //       let type = `${this.allowedMimeType.map((i) =>
  //         (
  //           mimeTypeExtensions.find(x => x.type === i) || { type: i }
  //         ).type).join(', ')}`;
  //       console.log('type');
  //       console.log(type);

  //       //
  //       console.log(' element.type ');
  //       console.log( element.type );

  //       //llamamos al metodo de verficacon el tipo de documento ingresado
  //       console.log('this.upLoadTypeFile(element)');
  //       console.log( this.upLoadTypeFile(element) );


  //       //#region prueba1

  //       // if(element.size > this.fileLimit)
  //       // {
  //       //   // this.alert.open('El archivo superó el límite permitido');
  //       //   //console.log('el archivo supero el limite');
  //       //   // lo eliminamos
  //       //   this.deleteAttachment(index);
  //       //   this.upLoadFileValue.emit(false);
  //       //   // clean
  //       //   //event = null;
  //       //   this.upLoadFile.emit(null);
  //       //   // this.estadoCargaArchivo = this.ESTADONOTIFICACION.CARGADO;
  //       // }
  //       // else{
  //       //   // console.log(' mimeTypeExtensions[0].type ');
  //       //   // console.log( mimeTypeExtensions[0].type.toString() );

  //       //   // console.log(' element.type ');
  //       //   // console.log( element.type.toString() );

  //       //   if(
  //       //      element.type.toString()  === mimeTypeExtensions[0].type.toString()
  //       //   )
  //       //   {
  //       //   // this.estadoCargaArchivo = this.ESTADONOTIFICACION.CARGADO;
  //       //   // this.alert.open('Se cargó correctamente el archivo');
  //       //     console.log(' SE CARGÓ CORRECTAMENTE ');
  //       //     this.upLoadFileValue.emit(true);

  //       //     this.upLoadFile.emit(event);
  //       //   }
  //       //   else
  //       //   {
  //       //     console.log('el tipo de documento es incorrecto solo se aceptan .pdf');

  //       //     // lo eliminamos
  //       //     this.deleteAttachment(index);

  //       //     this.upLoadFile.emit(null);
  //       //   }
  //       // }

  //       //#endregion

  //       //#region prueba2



  //       //#endregion
  //   //     // console.log(this.dropdownValue);

  //   //   // let init_params = {};
  //   //   // this.init_params.action = 'prepare';
  //   //   // this.init_params.file_name = file.name;
  //   //   // this.init_params.file_size = fileSize;
  //   //   // this.init_params.moduleName = dpVal;

  //   //   // ws.send(JSON.stringify(init_params))
  //   //   // console.log("sending init params.....")

  //   }

  //     //#endregion


  //   }
  // }
  //#endregion

  //#region official upLoadLimitFile
  // upLoadLimitFile(event){
  //   console.log('event in upLoadLimitFile');
  //   console.log(event);

  //   if(event)
  //   {
  //     // for (let index = 0; index < event.length; index++)
  //      {
  //       const element = event;
  //       // this.files.push(element.name)
  //       console.log('this.files.length');
  //       console.log(this.files.length);
  //       console.log('element');
  //       console.log(element);

  //       if (element.size > 1024 * 1024)
  //         this.fileSize = (Math.round(element.size * 100 / (1024 * 1024)) / 100).toString() + 'MB';
  //       else
  //         this.fileSize = (Math.round(element.size * 100 / 1024) / 100).toString() + 'KB';

  //       console.log('this.fileSize');
  //       console.log(this.fileSize);

  //       console.log('element.size');
  //       console.log(element.size);

  //       // 6  megabyte equivalentes byte = 6291456
  //       // 20 megabyte equivalentes byte = 20971520
  //       console.log('this.fileLimit');
  //       console.log(this.fileLimit);

  //       if(element.size > this.fileLimit)
  //       {
  //         console.log('el archivo supero el limite');
  //         // lo eliminamos
  //         // this.deleteAttachment(index);
  //         // clean
  //         //event = null;
  //         // this.upLoadFile.emit(null);
  //         return false;
  //         // this.estadoCargaArchivo = this.ESTADONOTIFICACION.CARGADO;
  //       }
  //       else{
  //         console.log(' SE CARGÓ CORRECTAMENTE ');
  //         // this.upLoadFile.emit(event);
  //         return true;
  //       }
  //     }
  //   }
  // }
  //#endregion

  uploadFile(event:any) {

    if(event.length > 1)//EVITAMOS SUBIR MAS DE UN ARCHIVO
    {
      let message = 'Sólo se acepta subir un documento';
      //console.log('event es mayor a 1');
      this.onWhenAddingFileFailed.emit(message);
      return false;
    }

    for (let index = 0; index < event.length; index++) {
      const element = event[index];
      this.files.push(element.name)
      // console.log('this.files.length');
      // console.log(this.files.length);
      // console.log('element');
      // console.log(element);

      // console.log('this.files.length 2°');
      // console.log(this.files.length);

      if(this.files.length > 0)
      {
        if (element)
        {
          //llamamos al metodo de verficacon el tipo de documento ingresado
          // console.log('this.upLoadTypeFile(element)');
          this.upLoadTypeFile(element);
        }
      }
    }
  }

  upLoadTypeFile(element){
    if(element)
    {
        // console.log('element');
        // console.log(element);
      if( element.type.toString()  === mimeTypeExtensions[0].type.toString() )
      {
          // this.estadoCargaArchivo = this.ESTADONOTIFICACION.CARGADO;
          // let message= 'EL ARCHIVO SUPERÓ EL LÍMITE PERMITIDO';
          // console.log(' SE CARGÓ CORRECTAMENTE ');
         //2° Validamos el limite permitido si excedio
         this.upLoadLimitFile(element);
        //  this.onWhenAddingFileFailed.emit(message);
      }
      else
      {
          let message= 'El Tipo de documento es incorrecto sólo se acepta archivo PDF';
          // console.log('el tipo de documento es incorrecto sólo se aceptan archivos PDF');
          this.deleteAttachment(0);
          // console.log('element');
          // console.log(element);
          this.upLoadFile.emit(null);
          this.onWhenAddingFileFailed.emit(message);
          return false;
      }
    }
  }

  upLoadLimitFile(element){
    // console.log('element in upLoadLimitFile');
    // console.log(element);

    if(element)
    {
        // console.log('element');
        // console.log(element);

        // 6  megabyte equivalentes byte = 6291456
        // 20 megabyte equivalentes byte = 20971520

        // console.log('this.fileLimit');//hardcode de la cantidad maxima permitida
        // console.log(this.fileLimit);

        if(element.size > this.fileLimit)
        {
          let message= 'El archivo superó el límite permitido';
          // console.log(' EL ARCHIVO SUPERÓ EL LÍMITE PERMITIDO ');
          //eliminamos el archivo
          this.deleteAttachment(0);
          // console.log('element');
          // console.log(element);
          // console.log('  this.upLoadFile.emit(null); ');
          this.upLoadFile.emit(null);
          this.onWhenAddingFileFailed.emit(message);
          return false;
        }
        else{
          let message= ' Se cargó correctamente el documento';
          // console.log(' SE CARGÓ CORRECTAMENTE ');
          // console.log('  this.upLoadFile.emit(event); ');
          this.upLoadFile.emit(element);
          this.onWhenAddingFileFailed.emit(message);
          return true;
        }
    }
  }




  validAddingFile( event, filter ){
    // 1° validar el tipo de documento
    // 2° validar el limite permitido del documento
  }

  upFile = (item, filter) => {
    let message = '';
    switch (filter.name) {
      case 'mimeType':
        message = `
        Sólo se permite archivo en formato
        ${this.allowedMimeType.map((i) =>
          (mimeTypeExtensions.find(x => x.type === i) || { extension: i }).extension).join(', ')}`;
        // console.log('message mimeType');
        // console.log(message);
        break;
      case 'fileSize':
        // message = `El archivo ${item.name} (${formatBytesString(item.size)}) excede el tamaño permitido (${formatBytesString(this.maxFileSize)})`;
        // console.log('message fileSize');
        // console.log(message);
        break;
      default:
        message = `Error al adjuntar el archivo ${item.name}`;
        // console.log('message default');
        // console.log(message);
        break;
    }
    this.onWhenAddingFileFailed.emit(message);
  }

  deleteAttachment(index) {
    this.files.splice(index, 1)
    this.deleteFile.emit(`Se eliminó correctamente el archivo con index: ${index}`);
  }
}
